module.exports = __webpack_public_path__ + "static/media/valor4_3.9eb58ba0.mp4";